import React from 'react';
import { Form, Input } from 'formik-antd';

const ExperienceLetter = (): React.ReactElement => {
  return (
    <>
      <h3>Experience Letter</h3>
      <Form.Item name={`entityName`} label="Entity Name if required">
        <Input name="entityName" />
      </Form.Item>
      <Form.Item name={`notes`} label="Additional Notes">
        <Input.TextArea name="notes" />
      </Form.Item>
    </>
  );
};

export default ExperienceLetter;
